import { gql } from '@apollo/client';

export const ActivityOutcomesFragment = gql`
  fragment ActivityOutcomesFragment on ActivityOutcomes {
    contentId
    contentType
    sectionId
    activityId
    outcomes {
      outcomeId
      parentOutcomeId
      outcome {
        id
        code
        curriculum
        description
        category
        type
        name
        nameCode
        dciCode
        dciName
        dciArrangements
        metaInfo
        version
        groupLabel
      }
      questionTypes
      proficiencies
      cerTypes
      contentPoints {
        id
        name
        content
      }
    }
  }
`;

export const UPSERT_ACTIVITY_OUTCOMES = gql`
  mutation UpsertActivityOutcomes($input: UpsertActivityOutcomesInput!) {
    upsertActivityOutcomes(input: $input) {
      ...ActivityOutcomesFragment
    }
  }
  ${ActivityOutcomesFragment}
`;
